import axios from "axios";
import { APP_ID, partnerURL } from "../config/config";
/**
 * Init FB Javascript SDK with dynamic APP ID
 *
 * @param {string} appId - The count of parameters.
 * @return {void}
 */
export const fbInit = ({ appId = APP_ID }) => {
  // Re-init FB JS SDK if session is already established
  if (window.FB) {
    const fbRoot = document.getElementById("fb-root");
    delete window.FB;
    if (fbRoot) {
      fbRoot.remove();
    }

    const fbScript = document.getElementById("facebook-jssdk");
    if (fbScript) {
      fbScript.remove();
    }

    return fbInit({ appId });
  }

  window.fbAsyncInit = function () {
    window.FB.init({
      appId,
      cookie: true,
      xfbml: true,
      version: "v14.0",
    });
  };

  (function (d, s, id) {
    var js,
      fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s);
    js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
  })(document, "script", "facebook-jssdk");

  window.waitForFbq = function (callback) {
    if (typeof window.fbq !== "undefined") {
      callback();
    } else {
      setTimeout(function () {
        window.waitForFbq(callback);
      }, 100);
    }
  };

  window.launchWhatsAppSignup = function () {
    window.waitForFbq(function () {
      window.fbq("trackCustom", "WhatsAppOnboardingStart", {
        appId,
        feature: "whatsapp_embedded_signup",
      });
    });
  };
};

/**
 * Re-init the FB SDK with the Meta app announced by the backend
 * (verify-connect-ads-link / onboard-project response). Direct-API partners
 * run on the no-label app; everyone else stays on the build-time default.
 *
 * @param {object} data - verify/onboard response body
 * @return {void}
 */
export const fbInitFromResponse = (data) => {
  if (data?.metaAdsAppKey === "ads-direct" && data?.appId) {
    fbInit({ appId: data.appId });
  }
};

export const handleWabaExternalEvent = async ({ event, partnerId, key }) => {
  if (!event.origin.endsWith("facebook.com")) return;
  try {
    let data;
    // parse data from event
    try {
      data = JSON.parse(event.data || "{}");
    } catch (error) {
      return;
    }

    if (data.type === "WA_EMBEDDED_SIGNUP") {
      //check if ES was completed by the user
      if (data.event.includes("FINISH")) {
        const { data: sessionData = {} } = data;

        let url = partnerURL + "/api/submit-facebook-access-token";
        if (!partnerId) {
          url += "?redirect=true";
        }

        const apiResponse = await axios.post(url, {
          sessionData,
          key,
        });

        return { esEvent: "FINISHED", apiResponse };
      }

      return { esEvent: data.event, apiResponse: null };
    }
  } catch (error) {
    console.error("Error handling WABA external event:", error);
    throw error;
  }
};
